import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  IconButton,
  ImageList,
  ImageListItem,
  ImageListItemBar,
  Modal,
  Typography,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { ArrowBackIos, ArrowForwardIos } from "@mui/icons-material";
import PropTypes from "prop-types";
import { useUpdate } from "react-admin";

const ImageGallerySlider = (props) => {
  const vehicleImages = props.vehicleImages;
  const [openImageModal, setOpenImageModal] = useState(false);
  const [currentImage, setCurrentImage] = useState("");
  const [currentImageIndex, setCurrentImageIndex] = useState(null);
  const [showNextButton, setShowNextButton] = useState(true);
  const [showPreviousButton, setShowPreviousButton] = useState(true);
  const [imageNumber, setImageNumber] = useState(0);
  const [numberOfImages, setNumberOfImages] = useState(0);
  const [openConfirmModal, setOpenConfirmModal] = useState(false);
  const [imageToDelete, setImageToDelete] = useState(null);
  const [deletedImages, setDeletedImages] = useState([]);
  const [update, { isLoading, error }] = useUpdate();

  let imageArray = [];

  const handleOpenPDF = (url) => {
    window.open(url, "_blank");
  };

  const handleOpenImageModal = (imageUrl, index) => {
    if (imageUrl !== currentImage) {
      setCurrentImage(imageUrl);
      setCurrentImageIndex(index);
      handleImageButtons(index);
    }

    if (openImageModal === false) {
      setOpenImageModal(true);
    }
  };
  const handleCloseImageModal = () => {
    if (currentImage !== "") {
      setCurrentImage("");
      setCurrentImageIndex(null);
    }

    if (openImageModal === true) {
      setOpenImageModal(false);
    }
  };

  const handleImageButtons = (index) => {
    let imageNumber = index + 1;
    let imageArrayLength = imageArray.length;

    setImageNumber(imageNumber);
    setNumberOfImages(imageArrayLength);
    setShowNextButton(true);
    setShowPreviousButton(true);

    if (imageNumber === imageArrayLength) {
      setShowNextButton(false);

      if (imageArrayLength > 1) {
        setShowPreviousButton(true);
      }
    }

    if (index === 0) {
      setShowPreviousButton(false);

      if (imageArrayLength > 1) {
        setShowNextButton(true);
      }
    }
  };

  const handleKeyDown = (e) => {
    if (openImageModal === true && e.key === "ArrowRight") {
      changeImage("next");
    }

    if (openImageModal === true && e.key === "ArrowLeft") {
      changeImage("previous");
    }
  };

  const changeImage = (direction) => {
    let newIndex;

    if (direction === "next") {
      newIndex = currentImageIndex + 1;
    } else {
      newIndex = currentImageIndex - 1;
    }

    if (imageArray[newIndex] !== undefined) {
      setCurrentImage(imageArray[newIndex]);
      setCurrentImageIndex(newIndex);
      handleImageButtons(newIndex);
    }
  };

  const handleDeleteImage = (e, image) => {
    e.stopPropagation();
    setImageToDelete(image);
    setOpenConfirmModal(true);
  };

  const handleConfirmDelete = async () => {
    if (imageToDelete) {
      update("vehicle-images", {
        id: "/api/vehicle-images/" + imageToDelete.id,
        data: { archived: true },
        previousData: imageToDelete,
      }).then(() => {
        setDeletedImages([...deletedImages, imageToDelete.url]);
      });

      if (currentImage === imageToDelete.url) {
        handleCloseImageModal();
      }
    }

    setOpenConfirmModal(false);
    setImageToDelete(null);
  };

  const handleCancelDelete = () => {
    setOpenConfirmModal(false);
    setImageToDelete(null);
  };

  useEffect(() => {
    document.addEventListener("keydown", handleKeyDown);

    return () => {
      document.removeEventListener("keydown", handleKeyDown);
    };
  });

  return (
    <React.Fragment>
      <ImageList cols={5}>
        {vehicleImages &&
          vehicleImages
            .slice(0)
            .reverse()
            .filter((image) => !deletedImages.includes(image.url))
            .map((image, index) => {
              if (image.url.indexOf("pdf") === -1) {
                imageArray.push(image.url);
                const modelIndex = imageArray.indexOf(image.url);
                return (
                  <ImageListItem
                    key={index}
                    onClick={() => {
                      handleOpenImageModal(image.url, modelIndex);
                    }}
                    sx={{
                      cursor: "pointer",
                      position: "relative",
                    }}
                  >
                    <img src={image.url} loading="lazy" alt={image.url} />
                    <IconButton
                      onClick={(e) => handleDeleteImage(e, image)}
                      sx={{
                        position: "absolute",
                        top: 4,
                        right: 4,

                        backgroundColor: "rgba(0, 0, 0, 0.6)",
                        color: "white",
                        padding: "4px",
                        "&:hover": {
                          backgroundColor: "rgba(0, 0, 0, 0.8)",
                        },
                      }}
                      size="small"
                    >
                      <CloseIcon fontSize="small" />
                    </IconButton>
                  </ImageListItem>
                );
              } else {
                return (
                  <ImageListItem
                    key={index}
                    onClick={() => {
                      handleOpenPDF(image.url);
                    }}
                    sx={{
                      cursor: "pointer",
                      justifySelf: "center",
                      alignSelf: "center",
                    }}
                  >
                    <img
                      alt={image.url}
                      height={50}
                      src="/pdf_placeholder.png"
                    />
                    <ImageListItemBar
                      position="bottom"
                      title={image.url.split("/").slice(-1)}
                    />
                  </ImageListItem>
                );
              }
            })}
      </ImageList>
      <Modal open={openImageModal} onClose={handleCloseImageModal}>
        <Box
          style={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            boxShadow: 24,
            maxWidth: "1920px",
            width: "85%",
            height: "85%",
          }}
        >
          <img
            src={`${currentImage}`}
            style={{
              border: "2px solid #000",
              maxWidth: "100%",
              maxHeight: "100%",
              display: "block",
              margin: "auto",
              position: "absolute",
              top: "0",
              bottom: "0",
              left: "0",
              right: "0",
            }}
          />
          <IconButton
            style={{
              position: "absolute",
              top: "-60px",
              right: "0",
            }}
            onClick={handleCloseImageModal}
          >
            <CloseIcon
              style={{
                fill: "white",
                fontSize: "40px",
              }}
            />
          </IconButton>
          <Typography
            variant={"h3"}
            style={{
              position: "absolute",
              top: "-60px",
              left: "0",
              color: "white",
            }}
          >
            {imageNumber + " / " + numberOfImages}
          </Typography>
          {showNextButton && (
            <IconButton
              onClick={() => {
                changeImage("next");
              }}
              style={{
                position: "absolute",
                right: "-60px",
                top: "50%",
              }}
            >
              <ArrowForwardIos
                style={{
                  fill: "white",
                  fontSize: "40px",
                }}
              />
            </IconButton>
          )}
          {showPreviousButton && (
            <IconButton
              onClick={() => {
                changeImage("previous");
              }}
              style={{
                position: "absolute",
                left: "-60px",
                top: "50%",
              }}
            >
              <ArrowBackIos
                style={{
                  fill: "white",
                  fontSize: "40px",
                }}
              />
            </IconButton>
          )}
        </Box>
      </Modal>
      <Modal open={openConfirmModal} onClose={handleCancelDelete}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            backgroundColor: "white",
            boxShadow: 24,
            padding: 4,
            borderRadius: 2,
            minWidth: 300,
            maxWidth: 500,
          }}
        >
          <Typography variant="h6" component="h2" gutterBottom>
            Delete Image
          </Typography>
          <Typography variant="body1" sx={{ mb: 3 }}>
            Are you sure you want to delete this image?
          </Typography>
          <Box sx={{ display: "flex", justifyContent: "flex-end", gap: 2 }}>
            <Button variant="outlined" onClick={handleCancelDelete}>
              Cancel
            </Button>
            <Button
              variant="contained"
              color="error"
              onClick={handleConfirmDelete}
            >
              Delete
            </Button>
          </Box>
        </Box>
      </Modal>
    </React.Fragment>
  );
};

ImageGallerySlider.propTypes = {
  vehicleImages: PropTypes.array,
};

export default ImageGallerySlider;
